<template>
  <span
    v-if="nextEpisode.id"
    v-accessibility-focus="playNextEpisode"
    class="o-typography__label o-button__label"
  >
    {{ event.title }}&nbsp;{{ timeToNextEpisode }}s
  </span>
</template>
<script>
  import { NextEpisodeMixin } from '@/shared/components/player/mixins';
  import { PlayerStatus } from '@/shared/components/player/enums';
  import { state } from '@/shared/components/player/store';

  export default {
    name: 'UiNextEpisodeAction',
    mixins: [
      NextEpisodeMixin,
    ],
    props: {
      event: Object,
    },
    data() {
      return {
        interval: undefined,
        timeToNextEpisode: 15,
      };
    },
    created() {
      this.interval = window.setInterval(() => {
        if (state.playerStatus !== PlayerStatus.PAUSE) {
          this.timeToNextEpisode--;
          if (this.timeToNextEpisode === 0) {
            window.clearInterval(this.interval);
            this.playNextEpisode();
          }
        }
      }, 1000);
    },
    beforeDestroy() {
      window.clearInterval(this.interval);
    },
  };
</script>
